import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/manga';

export default function CategorySection() {
  const { t } = useTranslation();
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            {t('home.category.title')}
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            {t('home.category.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 text-center hover:bg-primary-50/50 transition-all cursor-pointer border border-background-200/60 hover:border-primary-200/60"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1 font-heading">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400">{cat.count} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}